<div #container [ngClass]="isFullScreen ? 'vib-imageContainer-fulscreen' : 'vib-imageContainer'">
	<div class="vib-SensorCanvas" id="locationimage">
		@if (inputSubLocation.Level > 1) {
		<img #image class="vib-sensorGroupImage"
			src="{{imagePathSubLocations()}}{{inputSubLocation.Id}}?{{inputSubLocation.Modified}}"
			title="{{inputSubLocation.Name}} - {{inputSubLocation.LocationType}}"
			onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
			[attr.x-contenttype]="'image/png'">
		}
		@if ((width > 0 && height > 0) && inputSubLocation.Assets && inputSubLocation.Assets.length > 0) {
		<div class="tiles-canvas" [style.left.px]="left" [style.top.px]="top" [ngClass]="{'edit-border': sensorEdit}"
			[style.width.px]="width" [style.height.px]="height">
			@for (asset of inputSubLocation.Assets; track $index) {
			<app-asset-tile [accountGUID]="accountGUID" [OrganisationUID]="OrganisationUID" [asset]="asset"
				[imageElement]="imageElement" [isFullScreen]="isFullScreen" (click)="assetSelect(asset)" />
			}
		</div>
		}
	</div>
	@if (!isFullScreen) {
	<div class="edit-toolbar">
		@if (AdminSite) {
		<span mat-icon-button class="app-icon app-icon--edit siteAdmin-only-outline"
			matTooltip="Edit {{inputSubLocation.Name}} Details" matTooltipPosition="above"
			(click)="editLocation(inputSubLocation)">
			<mat-icon style="padding-bottom: 26px;color: lightgray;" />
		</span>
		}
		@if (inputSubLocation.Assets && !isMobileView) {
		<span style="display:flex; flex-direction: column;">
			@if (!sensorEdit) {
			<span mat-icon-button matTooltip="Move Asset Tiles" matTooltipPosition="right" class="point-hand"
				(click)="moveSensor()">
				<mat-icon>build</mat-icon>
			</span>
			} @else {
			<span mat-icon-button matTooltip="Save Tile Positions" matTooltipPosition="right" class="point-hand"
				(click)="savePositions(true)">
				<mat-icon>save</mat-icon>
			</span>

			<span mat-icon-button matTooltip="Cancel Changes" matTooltipPosition="right" class="point-hand"
				(click)="savePositions(false)">
				<mat-icon>close</mat-icon>
			</span>
			}
		</span>
		}
	</div>
	}
	<div class="expand-toolbar">
		<span mat-icon-button class="app-icon"
			[ngClass]="isFullScreen ? 'app-icon--exit-fullscreen' : 'app-icon--fullscreen'"
			[matTooltip]="(!isFullScreen ? 'Expand to ' : 'Exit ') + 'Full Screen'"
			(click)="trueFullscreen(container, !isFullScreen)">
			<mat-icon class="expand-button" />
		</span>
	</div>
</div>